import VuexStore from "../store";

const newFetch = (url, params) => {
  return new Promise((resolve, reject) => {
    fetch(url, params)
      .then((response) => {
        if (response.status === 401) {
          localStorage.removeItem("user");
          localStorage.removeItem("accessToken");

          VuexStore.commit("LoginStore/setLogged", false);
          VuexStore.commit("LoginStore/setUserLogged", {});
          window.location = "/";
        }
        return response.json();
      })
      .then((data) => resolve(data))
      .catch((e) => {
        reject(e);
      });
  });
};

export const fetchBlob = (url, params) => {
  return new Promise((resolve, reject) => {
    fetch(url, params)
      .then((response) => response.blob())
      .then((data) => resolve(data))
      .catch((e) => {
        reject(e);
      });
  });
};

export default newFetch;
